// i18n area 'cluster' — locale hr-HR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.hr-HR.meta.json.
import type { enUS } from './cluster'

export const hrHR: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Jamstveni pristupi',
      subtitle: 'Servisna vrata čvora: pristup samo za čitanje s privremenom lozinkom i hitni račun s lozinkom iz sefa',
      readOnlyTitle: 'Pristup samo za čitanje (trantor)',
      stateNone: 'zatvoren',
      stateGranted: 'otvoren',
      stateGrantedPending: 'odobren — primjenjuje se na čvoru',
      grantedBy: 'Odobrio',
      grantedAt: 'Odobreno',
      expiresAt: 'Istječe',
      reason: 'Razlog',
      endedAt: 'Zatvoren',
      endedReason: {
        revoked: 'opozvan',
        expired: 'istekao (TTL)',
        reboot: 'ponovno pokretanje čvora',
        failed: 'nije primijenjen (zadatak nije uspio)'
      },
      grant: 'Odobri pristup samo za čitanje…',
      grantTitle: 'Odobri pristup samo za čitanje',
      grantSubmit: 'Odobri',
      grantError: 'Odobrenje je odbijeno',
      grantConfirm: 'TVirt generira privremenu lozinku za sustavskog korisnika «trantor» (samo čitanje: journal i dijagnostika, bez sudo) i postavlja je na čvoru zadatkom. Lozinka se prikazuje SAMO jednom, pri potvrdi; prestaje istekom, opozivom ili pri sljedećem ponovnom pokretanju čvora.',
      reasonLabel: 'Razlog',
      reasonHint: 'Zašto otvarate vrata: ostaje u odobrenju, u reviziji i u dnevniku',
      ttlLabel: 'Trajanje',
      ttlHours: '{n} h',
      revoke: 'Opozovi pristup samo za čitanje…',
      revokeTitle: 'Opozovi pristup samo za čitanje',
      revokeSubmit: 'Opozovi',
      revokeError: 'Opoziv je odbijen',
      revokeConfirm: 'Odobrenje prestaje odmah i zadatak ponovno zaključava korisnika «trantor» na čvoru: privremena lozinka prestaje vrijediti.',
      passwordTitle: 'Lozinka samo za čitanje',
      passwordOnce: 'Ova se lozinka prikazuje SAMO jednom: kopirajte je sada. Nigdje se ne sprema i neće se moći ponovno pročitati — ako je izgubite, odobrite ponovno.',
      passwordUser: 'Korisnik',
      passwordLabel: 'Lozinka',
      passwordHint: 'Vrijedi do {until} ili do sljedećeg ponovnog pokretanja čvora; upotrebljiva kad je zadatak odobrenja dovršen. Pristup: ssh trantor@<adresa čvora>.',
      emergencyTitle: 'Posljednji hitni pristup (trantor-emergency)',
      lastLogin: '{time} putem {via} s {from}',
      lastLoginNone: 'ništa zabilježeno',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konzola',
        sudo: 'sudo',
        unknown: 'nepoznato'
      },
      emergencyHint: 'Hitni račun «trantor-emergency» (puni sudo) uvijek je omogućen s lozinkom generiranom pri instalaciji čvora i čuvanom u sefu: TVirt je ne zna, ne rotira i ne obnavlja. Svaka prijava prijavljuje se ovdje i u dnevniku događaja.'
    },
    nodeFirewall: {
      tab: 'Vatrozid',
      title: 'Vatrozid čvorova',
      subtitle: 'Stav nftables ruleseta koji svaki čvor primjenjuje na sebe — jedini vatrozid čvora (firewalld je onemogućen)',
      modeLabel: 'Stav',
      mode: {
        disabled: 'Onemogućeno — nema ruleseta na čvorovima',
        permissive: 'Permisivno — broji i bilježi, ništa ne odbacuje',
        enforced: 'Primijenjeno — ulazi samo izvedeni registar'
      },
      hint: {
        disabled: 'Kako je danas: čvorovi ne nose nikakav ruleset. Prijeđite na permisivno da PROČITATE što bi bilo odbačeno prije nego što bude odbačeno.',
        permissive: 'Svaki čvor primjenjuje svoj izvedeni ruleset s policy accept: ono što bi primijenjeni način odbacio broji se i bilježi (prefiks u journalu «tvirt-node would-drop:»). Ništa se ne blokira.',
        enforced: 'Svaki čvor primjenjuje svoj izvedeni ruleset s policy drop: ssh i API odasvud, store / live migration / overlay / Ceph samo od članova, listeneri mrežnih servisa iz posluživane mreže. Svaka je promjena apply s potvrdom — čvor koji ne uspije potvrditi sam se vraća natrag.'
      },
      confirmTitle: 'Primijeniti vatrozid čvorova?',
      confirmBody: 'Svaki čvor primjenjuje ruleset s potvrdom: sondira backend, store i ssh kroz nova pravila unutar roka i potvrđuje — inače se sam vraća na prethodni ruleset. Prvo pročitajte brojače permisivnog načina na čvorovima.',
      confirmSubmit: 'Primijeni',
      confirmCancel: 'Odustani',
      lensTitle: 'Vatrozid čvora',
      loadError: 'Nije moguće učitati leću vatrozida čvora',
      noReport: 'Još nema izvještaja o vatrozidu s ovog čvora — worker javlja pri sljedećem prolazu',
      firewalldActive: 'Na ovom čvoru radi firewalld: vatrozid čvora odbija se primijeniti pokraj njega (maskirajte firewalld)',
      conditionUnconfirmed: 'Još nema potvrđenog ruleseta — čvor je otvoren',
      conditionRolledBack: 'Zadnji apply se vratio natrag — ista se generacija ne pokušava ponovno dok se registar ne promijeni ili se stav ponovno ne promijeni',
      lastError: 'Zadnja pogreška',
      posture: 'Stav',
      observedAt: 'Opaženo',
      desiredGeneration: 'Željena generacija',
      componentTitle: 'Komponenta čvora',
      componentSubtitle: 'tvirt-node-firewall — pri bootu primjenjuje potvrđeni ruleset, nepotvrđeni sam vraća natrag',
      componentAbsent: 'Komponenta se još nije javila',
      phase: 'Faza',
      phases: {
        none: 'Nikad primijenjeno',
        applied: 'Primijenjeno — čeka potvrdu',
        confirmed: 'Potvrđeno',
        rolledBack: 'Vraćeno natrag'
      },
      generation: 'Generacija',
      appliedAt: 'Primijenjeno',
      confirmedAt: 'Potvrđeno',
      deadline: 'Rok za rollback',
      lastRollback: 'Zadnji rollback',
      registryTitle: 'Izvedeni registar',
      registrySubtitle: 'Portovi koje ovaj čvor otvara, po klasi i podrijetlu — izvedeni iz klastera, nikad ručno uređivani',
      registryEmpty: 'Ništa nije izvedeno — stav onemogućen bez potvrđenog ruleseta, ili još nema izvještaja',
      colClass: 'Klasa',
      colPort: 'Port',
      colSource: 'Izvor',
      colOrigin: 'Podrijetlo',
      classes: {
        public: 'Javna',
        internode: 'Međučvorna',
        tenant: 'Tenant'
      },
      sourceMembers: 'samo članovi',
      sourceAnywhere: 'odasvud',
      sourceBridge: 'na {iface}'
    },
    derivationDerived: 'izveden',
    derivationDiverged: 'odstupljen',
    derivationDerivedTip: 'Mrežni dokument je IZVEDEN iz fabrica {fabric} i još se podudara s renderom na trenutnim ulazima — klik za plan derivacije.',
    derivationDivergedTip: 'Derivacija iz fabrica {fabric} promijenila se nakon zadnjeg applyja (fabric, ožičenje, uloge ili reference) — klik za čekajući diff.',
    derivationRetiring: {
      one: '{n} adresa se prazni',
      few: '{n} adrese se prazne',
      other: '{n} adresa se prazni'
    },
    standaloneHint: 'Ovaj čvor nema klaster: još nije instaliran. Klasteri se pri instalaciji stvaraju ILI se pristupa postojećima (join) — join token izdan iz tablice Poslužitelji jednog od članova daje se installeru (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Vaše dozvole pokrivaju jedan scope, a ne cijeli klaster: inventar flote — čvorovi, postavke i uređaji — vidljiv je samo administratorima klastera.',
    phaseReady: 'Spreman',
    phaseForming: 'U formiranju',
    storeMembers: 'Članovi storea',
    watermark: 'Prag konvergencije',
    configGeneration: 'Generacija konfiguracije',
    converged: 'usklađeno',
    behind: 'kasni — {m} / {n}',
    revision: 'Revizija',
    rolesTitle: 'Mrežne uloge',
    rolesSubtitle: 'Adrese po članu za svaku klasu prometa — sama povezanost živi u mreži hosta',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'nasljeđuje management',
    settingsTitle: 'Postavke',
    settingsSubtitle: 'Sigurnosna politika na razini klastera — svaki je čvor procjenjuje iz svoje lokalne replike',
    taskRetentionTitle: 'Zadržavanje zadataka',
    taskRetentionSubtitle: 'Objedinjeni GC za sve zadatke — dovršeni zadaci koji prekorače starost ili gornju granicu se skupljaju, oni u tijeku nikada',
    taskRetentionMaxAge: 'Najveća starost (dani)',
    taskRetentionMaxCount: 'Najveći broj zadataka',
    eventRetentionTitle: 'Zadržavanje događaja',
    eventRetentionSubtitle: 'GC dnevnika — politika neovisna o zadacima: zadatak je red, događaj je memorija',
    eventRetentionMaxAge: 'Najveća starost (dani)',
    eventRetentionMaxCount: 'Najveći broj događaja',
    spaceThresholdsTitle: 'Pragovi prostora',
    spaceThresholdsSubtitle: 'Kada pohrana koja se puni dospije u dnevnik (i obavijesti)',
    spaceLowPct: 'Upozorenje od (% iskorišteno)',
    spaceCriticalPct: 'Kritično od (% iskorišteno)',
    spaceOrderError: 'Kritično ne može biti ispod upozorenja',
    spaceThresholdsHint: 'Konfiguriraju se samo ulazi: izlaz izvodi motor, 5 bodova ispod svakog praga, da pohrana na liniji nikada ne postane metronom',
    failoverReserveTitle: 'Pričuva za failover',
    failoverReserveSubtitle: 'Admission control N+1 — RAM koji se drži slobodnim kako bi klaster mogao ponovno pokrenuti svoje opterećenje nakon gubitka čvorova',
    failoverReserveTolerate: 'Broj čvorova čiji se gubitak tolerira',
    failoverReserveOff: '0 — pričuva je isključena: nijedno pokretanje nikad se ne odbija zbog failover kapaciteta',
    failoverReserveOn: 'Pokretanje koje bi načelo pričuvu odbija se s pogreškom 412 koja objašnjava brojke',
    networkShapingTitle: 'Pravednost propusnosti',
    networkShapingSubtitle: 'Tri tipološke težine shaping stabla po uplinku — djeluju samo pod natjecanjem',
    networkShapingRest: 'Težina ostatka (upravljačka ravnina, storage, replike)',
    networkShapingOverlay: 'Težina overlay mreža',
    networkShapingLiveMigration: 'Težina live migracije',
    networkShapingHint: 'Zajamčeni udio = težina / zbroj triju (zadano 300 / 100 / 200, svaka od 1 do 10000); na slobodnoj vezi svaka klasa može uzeti cijelu propusnost',
    debugModeTitle: 'Debug način',
    debugModeSubtitle:
      'Detaljne pogreške u općim GUI obavijestima — da vidite stvarni uzrok kada „neuspjela” radnja zapravo uspije',
    debugModeLabel: 'Debug način uključen',
    debugModeOn: 'Opće obavijesti o pogrešci dodaju temeljni uzrok — interni detalji vidljivi svakom operateru',
    debugModeOffHint: 'Isključeno — opće obavijesti o pogrešci ostaju opće, bez internih detalja',
    nodeDetailsAction: 'Detalji čvora',
    node: {
      docTitle: 'Čvor',
      notFound: 'Čvor nije pronađen',
      tabOverview: 'Pregled',
      tabStats: 'Statistika',
      tabNetwork: 'Mreža',
      tabSettings: 'Lokalne postavke',
      identityTitle: 'Identitet',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL port',
      revision: 'Revizija konfiguracije',
      versionsTitle: 'Opažene verzije',
      heartbeatSubtitle: 'Ono što je čvor zadnje javio o sebi',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Model CPU-a',
      memoryTitle: 'Memorija',
      hugePagesTitle: 'Goleme stranice',
      hugePagesPool: '{size}: slobodno {free} od {total}',
      hugePagesNone: 'Nema poola',
      hugePagesNoneHint: 'Čvor nema rezerviranih golemih stranica: VM-ovi koji ih traže ovdje se ne mogu pokrenuti. Pool se deklarira na čvoru, kernelskim parametrima hugepagesz i hugepages ili upisom u nr_hugepages.',
      usageTitle: 'Trenutačna upotreba',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'nije opaženo — nema svježeg uzorka',
      statsNoData: 'Nema podataka za odabrani raspon — serije čvora uzorkuje sam čvor i poslužuje ih lokalno.',
      observedTitle: 'Opaženo stanje',
      observedSubtitle: 'Servisi i asseti lokalni čvoru, kako ih vidi worker'
    },
    editRolesTitle: 'Uredite mrežne uloge',
    memberNode: 'Čvor',
    memberIp: 'IP adresa',
    addMember: 'Dodaj člana',
    lmInherit: 'Koristi management adrese',
    roleIpHint: 'Dodavanje i uklanjanje članova je slobodno; izmjena IP-a postojećeg člana na mjestu se odbija — tijek migracije IP-a stiže u kasnijoj rundi.',
    roleError: 'Nije moguće ažurirati uloge',
    nodesTitle: 'Čvorovi',
    addNodeTitle: 'Dodajte čvor u klaster',
    addNode: 'Dodaj čvor',
    addNodeError: 'Nije moguće predregistrirati čvor',
    nodeName: 'Naziv čvora',
    nodeNameHint: 'mora se podudarati s nazivom postavljenim pri instalaciji',
    nodeIp: 'Management IP',
    colName: 'Naziv',
    colPhase: 'Faza',
    colServices: 'Servisi',
    colWatermark: 'Watermark',
    colLastSeen: 'Zadnji kontakt',
    colUps: 'UPS',
    upsCordonChip: 'UPS kordon',
    upsCordonTip: 'Čvor se osudio na temelju činjenica svog UPS-a ({time}): sam uklanja kordon kad mreža postane stabilna, a baterija napunjena',
    upsUnreachable: 'UPS nedostupan',
    upsOnBattery: 'Na bateriji',
    upsOnLine: 'Na mreži',
    upsLowBattery: 'slaba baterija',
    upsNoEstimateChip: 'autonomija nije procijenjena',
    upsNoEstimateTip: 'UPS ne objavljuje procjenu autonomije: čvor se osuđuje samo LB zastavicom (slaba baterija) UPS-a — podesite battery.runtime.low / LB na samom UPS-u',
    upsLaneTip: 'UPS put gašenja od {since}: osuđen zbog {by}',
    upsUnit: 'jedinica',
    upsStatus: 'NUT stanje',
    upsLoad: 'opterećenje',
    upsOnBatterySince: 'na bateriji od',
    upsOnLineSince: 'na mreži od',
    upsError: 'greška',
    upsObservedAt: 'promatrano',
    upsNone: 'nijedna UPS jedinica ne opslužuje ovaj čvor',
    upsBy: {
      runtime: 'autonomija ispod praga',
      lowBattery: 'LB zastavica UPS-a',
    },
    upsLane: {
      evacuate: 'evakuacija',
      local: 'gašenje na mjestu',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'zaustavljanje gostiju',
      stoppingServices: 'zaustavljanje servisa',
      poweredOff: 'ugašen',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS jedinice i pragovi: čvor osuđen pri autonomiji ≤ prag ili LB zastavici (uvijek poštovana), nastavak s histerezom',
    upsRuntimeThreshold: 'Prag autonomije (s)',
    upsRuntimeThresholdHint: 'Na bateriji, s procijenjenom autonomijom ≤ prag čvor se gasi po redu (zadano 300)',
    upsResumeStable: 'Mreža stabilna tijekom (s)',
    upsResumeStableHint: 'Nastavak samo uz neprekinutu mrežu najmanje toliko sekundi (zadano 60)',
    upsResumeCharge: 'Minimalna napunjenost pri nastavku (%)',
    upsResumeChargeHint: 'I baterija napunjena barem do ovog postotka (zadano 25)',
    upsPolicyNote: 'LB zastavica (slaba baterija) UPS-a uvijek osuđuje i ne može se isključiti; ne postoji prag na vrijeme provedeno na bateriji. Svaka jedinica može prepisati ta tri broja.',
    upsUnitNew: 'nova jedinica',
    upsUnitSelectors: '{n} selektor(a) po oznakama (samo CLI)',
    upsUnitName: 'Naziv jedinice',
    upsUnitMode: 'Način',
    upsModeExternal: 'vanjska (tuđi upsd)',
    upsModeManaged: 'upravljana (UPS spojen na čvor)',
    upsUnitUpsname: 'NUT naziv (upsname)',
    upsUnitHost: 'upsd host',
    upsUnitAttachedNode: 'Spojeni čvor',
    upsUnitDriver: 'NUT upravljački program',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Uređaj upravljačkog programa',
    upsUnitDeviceHint: 'redak port= u ups.conf: prazno = auto',
    upsUnitPort: 'upsd port',
    upsUnitServedNodes: 'Opsluživani čvorovi',
    upsUnitServedNodesHint: 'nazivi čvorova odvojeni zarezima (selektori po oznakama idu kroz CLI)',
    upsUnitOverrideHint: 'prazno = zadano klastera',
    upsUnitAdd: 'Dodaj jedinicu',
    unreachableSince: 'Nedostupan — zadnji heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay dataplane još nije ostvario trenutačnu overlay konfiguraciju',
    overlaysError: 'Zadnji prolaz usklađivanja overlaya nije uspio: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Čeka join',
      'joining': 'Pristupa',
      'member': 'Član'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Prikazan samo sada — odmah ga kopirajte, više ga nikada neće biti moguće pročitati',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    close: 'Zatvori',
    revokeTitle: 'Opozovite predregistraciju',
    revoke: 'Opozovi',
    revokeError: 'Nije moguće opozvati registraciju',
    promote: 'Promakni u store membera',
    demote: 'Ukloni ulogu store-membera',
    troubleshoot: 'Otklanjanje poteškoća',
    promoteTitle: 'Promaknite u store membera',
    demoteTitle: 'Uklonite ulogu store-membera',
    promoteHint: 'Čvor ulazi u kvorum YugabyteDB mastera. Pravi HA zahtijeva tri store membera.',
    demoteHint: 'Čvor izlazi iz kvoruma mastera i zaustavlja svoje store servise.',
    storeError: 'Izmjena store-membera je odbijena',
    attest: 'Potvrdi da je isključen…',
    attestTitle: 'Potvrdite da je čvor isključen',
    attestSubmit: 'Potvrdi da je isključen',
    attestConfirm: 'Ovaj čvor proglašavate isključenim, na vlastitu odgovornost: potvrđivanje čvora koji je zapravo živ riskira dvostruko pokrenute VM-ove. Njegovi se zadaci označavaju neuspješnima, a authority svakog njegovog VM-a postaje prenosiv.',
    attestError: 'Potvrda isključenosti je odbijena',
    attestedChip: 'potvrđeno isključen',
    maintenanceChip: 'održavanje',
    guestToolsChip: 'TVirt Guest Tools (ISO asset lokalan čvoru)',
    maintenanceEnter: 'Uđi u održavanje',
    maintenanceExit: 'Izađi iz održavanja',
    maintenanceEnterTitle: 'Uđite u održavanje',
    maintenanceExitTitle: 'Izađite iz održavanja',
    maintenanceEnterSubmit: 'Uđi u održavanje',
    maintenanceExitSubmit: 'Izađi iz održavanja',
    maintenanceEnterConfirm: 'Čvor se stavlja u kordon i prazni: mrežne usluge i App instance čiji authority drži prenose se (instance na hladno: zaustavljene i požnjevene ovdje, ponovno stvorene na odredišnom čvoru — prekid), pokrenute VM migriraju se uživo gdje je moguće, inače se uredno zaustavljaju, zadaci u tijeku završavaju, novi posao čeka, a zaustavljene VM gube svoj authority — Proximity ih ponovno smješta pri sljedećem pokretanju. Ništa se ne vraća samo na kraju održavanja.',
    maintenanceExitConfirm: 'Čvor ponovno preuzima posao i Proximity ga opet uzima u obzir za smještaj. VM-ovi se vraćaju tek kada ih se pokrene.',
    maintenanceError: 'Zahtjev za održavanje je odbijen',
    maintenancePlanTitle: 'Plan evakuacije',
    maintenancePlanLoading: 'Izračun plana evakuacije…',
    maintenancePlanError: 'Plan evakuacije nije bilo moguće učitati — pražnjenje će svejedno migrirati gdje je moguće i zaustaviti ostalo.',
    maintenancePlanEmpty: 'Na ovom čvoru nema što evakuirati — nema aktivne mrežne usluge, nema App instance koja se želi pokrenuta, nema pokrenute VM.',
    maintenancePlanSummary: '{migrate} objekata će migrirati (VM, mrežne usluge, App instance), {stop} će se zaustaviti ili ostati gdje jesu.',
    maintenancePlanReserve_ok: 'Pričuva za failover nakon pražnjenja: netaknuta — još se može pokrenuti {headroom} GiB uz toleriranje gubitka čvorova: {n}.',
    maintenancePlanReserve_eroded: 'Pričuva za failover nakon pražnjenja: gotovo potrošena — ostalo je samo {headroom} GiB od {reserve} GiB koji se drže slobodnima za kvarove čvorova: {n}.',
    maintenancePlanReserve_exhausted: 'Pričuva za failover nakon pražnjenja: ISCRPLJENA — nedostaje {headroom} GiB od {reserve} GiB potrebnih za toleriranje kvarova čvorova: {n}. Dok je ovaj čvor izvan pogona, nova pokretanja VM-ova bit će odbijena.',
    maintenancePlanReserve_unknown: 'Pričuva za failover nakon pražnjenja: nije izračunljiva — nijedan preostali čvor nije prijavio svoju memoriju.',
    maintenancePlanReserveHugePages: 'Goleme stranice od {size} nakon pražnjenja — slobodno: {free} od {capacity}, potrebno kao pričuva: {reserve}.',
    maintenancePlanActionMigrate: 'migrira',
    maintenancePlanActionMigrateWarning: 'migrira (prekršeno soft pravilo)',
    maintenancePlanActionStop: 'zaustavlja se',
    maintenancePlanActionBlocked: 'blokiran',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'mrežna usluga',
    maintenancePlanKindApp: 'App instanca',
    maintenancePlanColdMove: 'Premještanje na hladno: pod se ovdje zaustavlja i žanje, a odredišni worker ga ponovno stvara — prekid do sljedećeg passa odredišnog workera.',
    caFingerprint: 'Fingerprint CA-a klastera',
    staleChip: 'zastario',
    troubleshootTitle: 'Otklanjanje poteškoća sa storeom',
    restartStore: 'Ponovno pokreni store servise',
    restartHint: 'Ako se store ponaša neobično, ponovno pokrenite njegove servise. Napredno — koristiti s oprezom.',
    restartQueued: 'Zadatak ponovnog pokretanja stavljen u red',
    restartError: 'Nije moguće ponovno pokrenuti servise',
    svcActive: 'aktivan',
    svcWanted: 'željen, nije pokrenut',
    svcStopped: 'zaustavljen',
    noServices: 'Nijedan servis nije prijavljen'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'GPU inventar cijelog klastera grupiran po modelu — opažene kartice po čvoru, s označenim registracijama i njihovim tagovima',
    usbTitle: 'USB resursi',
    usbSubtitle: 'USB inventar cijelog klastera grupiran po modelu — opaženi uređaji po čvoru, s registracijama obaju modela (po uređaju, po portu) i njihovim tagovima',
    markedChip: 'upotrebljivih za TVirt: {n}',
    orphanChipGpu: 'napuštenih: {n}',
    orphanChipUsb: 'napuštenih: {n}',
    colNode: 'Čvor',
    colRegistration: 'Registracija',
    noRegsHint: 'Još nema registracija — uređaj označite kao "upotrebljiv za TVirt" iz dijaloga čvora (Čvorovi › čvor › Postavke).',
    colDevice: 'Uređaj',
    colObserved: 'Opaženi',
    colRegs: 'Registracije',
    regsNone: 'nijedna',
    colPci: 'PCIe adresa',
    colIdentity: 'Identitet / port',
    colClasses: 'Klase (tagovi)',
    colActions: 'Radnje',
    manageOnNode: 'Upravljajte na čvoru {node} (označavanje živi u dijalogu čvora)',
    introTitle: 'Inventar USB i PCIe uređaja upotrebljivih za TVirt© na razini klastera.',
    introStep1: '1. Čvorovi sami otkrivaju svoje GPU-ove i USB uređaje (popis putem heartbeata).',
    introStep2: '2. Uređaj označavate kao "upotrebljiv za TVirt" iz dijaloga ČVORA (Čvorovi › čvor › Postavke) — označavanje ga veže uz vfio i registrira ovdje.',
    introStep3: '3. Ovdje registracijama dajete njihove KLASE putem tagova (npr. gpu_class=compute): zahtjevi VM-ova tražit će klasu, a scheduler bira čvor sa slobodnim odgovarajućim uređajem.',
    colMode: 'Način',
    colState: 'Stanje',
    colNotes: 'Bilješke',
    colTags: 'Tagovi',
    modeDevice: 'po uređaju',
    modePort: 'po portu',
    usable: 'upotrebljiv',
    orphanGpu: 'napuštena',
    orphanUsb: 'napušten',
    hubChip: 'hub',
    orphanPortsTitle: 'Registracije po portu bez priključenog uređaja — ponovno priključite uređaj ili im uklonite oznaku s čvora',
    gpusEmpty: 'Još nije opažen nijedan GPU ni na jednom čvoru',
    usbEmpty: 'Još nije opažen nijedan USB uređaj ni na jednom čvoru'
  },
  settings: {
    passwordMinLength: 'Najmanja duljina lozinke',
    sessionIdle: 'Timeout neaktivnosti sesije (minute)',
    lockoutThreshold: 'Zaključavanje nakon neuspjelih pokušaja',
    lockoutDuration: 'Trajanje zaključavanja (minute)',
    keyboardLayout: 'Raspored tipkovnice',
    keyboardLayoutHint: 'npr. it, en-us — prazno za zadanu vrijednost QEMU-a',
    syslogEndpoint: 'Syslog endpoint',
    syslogEndpointHint: 'host:port — prazno onemogućuje prosljeđivanje',
    syslogTls: 'TLS',
    maxQueued: 'Najveći broj zadataka u redu',
    concurrency: 'Istodobnost workera',
    concurrencyHint: 'Worker je primjenjuje u hodu',
    notesTitle: 'Bilješke',
    save: 'Spremi',
    saved: 'Postavke su spremljene',
    saveError: 'Nije moguće spremiti postavke'
  },
  localSettings: {
    derivedChip: 'izveden',
    derivedTip: 'Ovaj device je u VLASNIŠTVU derivacije fabrica (H2): editor ga odbija dirati — izmijenite fabric (ili ožičenje) i ponovno primijenite, ili ga uzmite natrag ispod.',
    takeOwnership: 'Preuzmi vlasništvo',
    takeOwnershipTitle: 'Preuzmi vlasništvo (take-ownership)',
    takeOwnershipConfirm: '{name} napušta fabric blok i ponovno postaje RUČNI device kojim upravlja ovaj editor. Čvor postaje odstupljen, a sljedeći apply derivacije na njemu će odbiti (manualConflict) dok ga ne preimenujete ili uklonite — ili ne ispravite fabric.',
    nodeSettingsTitle: 'Postavke čvora',
    nodeSettingsSubtitle: 'Ono što ovaj čvor provodi — red zadataka, konzola, prosljeđivanje zapisnika — plus njegovi tagovi i bilješke',
    baseTitle: 'Rezervacije hosta (TVirt Proximity)',
    baseSubtitle: 'CPU i RAM izdvojeni za operacijski sustav hosta — ulazni podaci empirijskog kapaciteta po kojem Proximity smješta VM-ove',
    baseMemory: 'Osnovni RAM (MiB)',
    baseMemoryHint: 'Opaženo ukupno: {total} MiB. Upotrebljivo za VM-ove = ukupno − osnovno − RAM pokrenutih VM-ova smještenih ovdje.',
    baseMemoryHintNoTotal: 'Upotrebljivo za VM-ove = opaženo ukupno − osnovno − RAM pokrenutih VM-ova smještenih ovdje.',
    baseCpu: 'Osnovne CPU jezgre',
    baseCpuHint: 'Opaženi logički CPU-i: {total}. Koristi se samo kao težina pri rangiranju — overcommit vCPU-a je normalan.',
    baseCpuHintNoTotal: 'Koristi se samo kao težina pri rangiranju — overcommit vCPU-a je normalan.',
    baseHint: 'RAM je stroga kontrola prijema: VM koji ne stane u upotrebljivi RAM odbija se s jasnom pogreškom. Povisite osnovne vrijednosti na hostovima na kojima rade članovi storea ili Ceph daemoni.',
    placementTitle: 'Fizički smještaj',
    placementSubtitle: 'Gdje ovaj poslužitelj fizički stoji — deklarira se jednom, čemu god služio',
    placementHint: 'Smještaj upravlja CRUSH hijerarhijom svakog Ceph klastera s OSD-om na ovom poslužitelju: spremanje promjene poravnava njihove mape putem zadatka (host → rack → … → root). Djelomične deklaracije su dopuštene — prazne razine jednostavno se urušavaju. Nazivi su zajednički cijeloj mapi: dva poslužitelja u istom racku deklariraju isti naziv racka.',
    placementNameInvalid: 'DNS-siguran naziv (mala slova, znamenke, spojnice)',
    placementEmpty: 'Prazno = nije deklarirano',
    placementLevel: {
      chassis: 'Šasija',
      rack: 'Rack',
      row: 'Red',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Prostorija',
      datacenter: 'Datacenter',
      zone: 'Zona',
      region: 'Regija'
    },
    cablingTitle: 'Kabliranje',
    cablingSubtitle: 'U koji je port preklopnika priključeno svako sučelje — deklaracija živi na čvoru (Annex O.9)',
    cablingHint: 'Jedan kabel po NIC-u, jedan kabel po portu na razini flote (API odbija navodeći tko ga drži). Kabliranje prema portu koji je član LAGG-a dopušteno je — to je bond slučaj: buduća derivacija prikazat će ga kao LACP.',
    cablingInterface: 'Sučelje',
    cablingNotCabled: '— nije kablirano —',
    cablingNoInterfaces: 'Još nije opaženo nijedno mrežno sučelje',
    disksTitle: 'Diskovi',
    disksSubtitle: 'Opaženi blok uređaji — jedno skeniranje po prolazu usklađivanja; ovdje označite diskove upotrebljive kao Ceph OSD-ovi (N.15: podobnost je eksplicitna)',
    colDataDisk: 'Podatkovni disk',
    dataDisksHint: 'Označavanje kvačicom deklarira uređaj upotrebljivim kao OSD; serijski broj njegov je identitetski pin — kopira se s hardvera kad ga uređaj prijavi, inače se kuje (tvirt-…). Dijalog registracije za Ceph nudi samo deklarirane diskove.',
    diskDeclaredSerial: 'deklariran',
    diskNotObserved: 'deklariran, ali nije opažen — ponovno priključite uređaj ili maknite kvačicu',
    noDisks: 'Još nije opažen nijedan blok uređaj',
    colSerial: 'Serijski broj',
    colModel: 'Model',
    colSize: 'Veličina (GiB)',
    colDiskType: 'Tip',
    colInUse: 'U upotrebi',
    colObservedAt: 'Opaženo',
    diskInUse: 'u upotrebi',
    diskFree: 'slobodan',
    diskMounted: 'montiran',
    diskPartitions: 'particije',
    passthroughTitle: 'Passthrough uređaji',
    passthroughSubtitle: 'Opaženi GPU-ovi i USB uređaji — ovdje označite što TVirt smije proslijediti VM-ovima; označavanje registrira identitet uređaja (runda U1+G1)',
    passthroughHint: 'Označavanje registrira uređaj (stabilan id — target tagova i klasnih zahtjeva). Označenom GPU-u CIJELA se IOMMU grupa odjednom veže na vfio-pci — odmah napušta host; uklanjanje oznake ponovno veže izvorni driver. Za USB postoje oba ratificirana modela: po uređaju (vendor+product, gdje god bio priključen) i po fizičkom portu (VM dobiva što god je ondje priključeno). USB se nikad ne veže pri označavanju — priključivanje se događa za vrijeme rada VM-a.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Upotrebljiv za TVirt',
    colGpu: 'GPU',
    colPciAddress: 'PCI adresa',
    colDriver: 'Driver',
    colVerdict: 'Presuda',
    gpuEligible: 'Podoban',
    gpuIneligible: 'Nije podoban',
    gpuReason: {
      'no-iommu': 'IOMMU nije aktivan na hostu',
      'group-spans-slots': 'IOMMU grupa nije izolirana: proteže se na druge slotove',
      'multiple-display': 'IOMMU grupa nije izolirana: više od jedne display funkcije',
      'foreign-function': 'IOMMU grupa nije izolirana: sadrži stranu funkciju'
    },
    vfioNotReady: 'IOMMU nije aktivan na ovom hostu: nijedan GPU nije podoban dok ga host platforma ne omogući (OEM ISO) — TVirt nikad ne dira kernel argumente za vrijeme rada.',
    vfioMissingKernelArg: 'IOMMU nije aktivan na ovom hostu: firmware prijavljuje VT-d/AMD-Vi (ACPI tablica DMAR/IVRS je prisutna), ali nedostaje kernel argument — dodajte intel_iommu=on (Intel) ili uklonite amd_iommu=off (AMD) iz kernelove naredbene linije i ponovno pokrenite sustav. TVirt nikad ne dira kernel argumente za vrijeme rada.',
    vfioFirmwareDisabled: 'IOMMU nije aktivan na ovom hostu: VT-d/AMD-Vi je onemogućen u firmwareu (nema ACPI tablice DMAR/IVRS) ili ga CPU ne podržava — omogućite ga u postavkama firmwarea, nijedan kernel argument ne može ga uključiti. TVirt nikad ne dira host za vrijeme rada.',
    gpuBindError: 'Bind vfio-pci nije uspio na {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Vatrozid na neupravljanim bridgeovima',
    firewallBridgesSubtitle: 'Ručno izgrađeni bridgeovi na ovom čvoru čiji setup pristaje na chainove vatrozida koje TVirt renderira na priključenim guest NIC-ovima',
    firewallBridgesHint: 'TVirt nikad ne dira tuđi bridge — chain se sidri na tap/veth, koji je uvijek TVirtov. Lista je vrata pristanka: default-deny i anti-spoof mogu slomiti ono što ručni setup očekuje, pa se NIC s vatrozidom na neupravljanom bridgeu koji NIJE ovdje naveden odbija uz rječitu grešku.',
    firewallBridgesEmpty: 'Nijedan neupravljani bridge na ovom čvoru ne pristaje na chainove vatrozida koje TVirt renderira.',
    firewallBridgeAdd: 'Dodaj bridge',
    firewallBridgeInvalid: 'Nije naziv Linux sučelja (1-15 znakova, bez kose crte i razmaka)',
    firewallBridgeDuplicate: 'Naziv je već na popisu',
    colMarkDevice: 'Po uređaju',
    colMarkPort: 'Po portu',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'napušten — registriran, ali više nije otkriven: ponovno ga priključite ili uklonite oznaku',
    noGpus: 'Još nije opažen nijedan GPU',
    noUsb: 'Još nije opažen nijedan USB uređaj',
    networkGeneration: 'Generacija mreže',
    applied: 'Primijenjena',
    converged: 'usklađeno',
    behind: 'kasni — {m} / {n}',
    notConfigured: 'nije konfigurirano',
    rollbackBody: 'Primjena generacije {gen} nije uspjela: {error}',
    rolledBackChip: 'rollback izveden',
    nicsTitle: 'NIC-ovi',
    nicsSubtitle:
      'Matični podaci upravljanih NIC-ova — registracija JEST deklaracija upravljanja: registrirani NIC bez konfiguracije ne dira se (clear-if ga izričito deklarira čistim), neregistrirani uređaj nikad se ne dira',
    addNic: 'Registriraj NIC',
    addNicTitle: 'Registrirajte NIC (add-nic)',
    delNic: 'Završi upravljanje',
    delNicTitle: 'Završite upravljanje (del-nic)',
    delNicConfirm:
      'Upravljanje uređajem {name} završava: matični zapis i njegova konfiguracija se uklanjaju, a TVirt profil briše — sam uređaj ostaje takav kakav je u Linuxu.',
    nicName: 'Naziv uređaja',
    nicMac: 'Trajna MAC adresa',
    nicMacHint: 'trajni hardverski MAC — stabilni identitet koji postavlja TVirt Server Installer',
    colObserved: 'Opažen',
    nicObserved: 'opažen',
    nicNotObserved: 'nije opažen',
    nicMacMismatch: 'MAC se ne podudara — opažen {mac}',
    noNics: 'Nijedan NIC nije registriran — registrirajte uređaj da biste njime počeli upravljati',
    noManagedDevices: 'Nema upravljanih uređaja — najprije registrirajte NIC, sve se gradi na matičnim podacima',
    inventoryTitle: 'Opaženi uređaji',
    inventorySubtitle: 'Osvježava ih worker čvora pri svakom prolazu usklađivanja — validacija provjerava nazive uređaja prema ovom inventaru',
    colDevice: 'Uređaj',
    colType: 'Tip',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Brzina',
    colTopology: 'Topologija',
    colMtu: 'MTU',
    colAddresses: 'Adrese',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP ne agregira',
    noInventory: 'Još nije prijavljen nijedan uređaj',
    interfacesTitle: 'Sučelja',
    interfacesSubtitle:
      'L3 konfiguracija registriranih NIC-ova i deklariranih logičkih uređaja — set-if zamjenjuje cijeli blok, edit-if prepravlja pojedinačna svojstva, clear-if ga prazni (izričito čišćenje)',
    colConfig: 'Željena konfiguracija',
    clean: 'čisto',
    setIf: 'Uredi adresiranje',
    setIfTitle: 'Uredite adresiranje (set-if)',
    editIf: 'Uredi svojstva',
    editIfTitle: 'Uredite svojstva (edit-if)',
    clearIf: 'Isprazni konfiguraciju',
    clearIfTitle: 'Ispraznite konfiguraciju (clear-if)',
    clearIfConfirm: 'Konfiguracija sučelja se prazni. Čisto je sučelje preduvjet da ga se podredi kao člana bonda/bridgea ili kao VLAN parenta.',
    ip4Mode: 'IPv4 način',
    ip6Mode: 'IPv6 način',
    modeUnconfigured: 'Nekonfigurirano',
    modeStatic: 'Statički',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4 adrese',
    ip6Addresses: 'IPv6 adrese',
    addressesHint: 'CIDR, odvojene zarezom',
    gw4: 'IPv4 pristupnik',
    gw6: 'IPv6 pristupnik',
    dns: 'DNS poslužitelji',
    dnsHint: 'odvojeni zarezom — prazno uklanja DNS (set-if zamjenjuje blok)',
    routes4: 'IPv4 statičke rute',
    routes6: 'IPv6 statičke rute',
    routeTo: 'Odredište (CIDR)',
    routeVia: 'Preko',
    addRoute: 'Dodaj rutu',
    routesChip: 'rute',
    mtu: 'MTU',
    mtuHint: 'prazno = zadana vrijednost drivera',
    vlansTitle: 'VLAN-ovi',
    addVlan: 'Dodaj VLAN',
    addVlanTitle: 'Dodajte VLAN (add-vlan)',
    delVlanTitle: 'Izbrišite VLAN (del-vlan)',
    vlanParent: 'Parent sučelje',
    vlanId: 'VLAN ID',
    vlanPreview: 'Naziv uređaja',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Nijedan VLAN nije deklariran',
    bondsTitle: 'Bondovi',
    addBond: 'Dodaj bond',
    addBondTitle: 'Dodajte bond (add-bond)',
    editBondTitle: 'Uredite bond',
    editBond: 'Spremi bond',
    delBondTitle: 'Izbrišite bond (del-bond)',
    bondName: 'Naziv bonda',
    members: 'Članovi',
    membersHint: 'članovi moraju biti čista sučelja (bez L3 konfiguracije)',
    bondMode: 'Način',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Primarni član',
    rate: 'LACP rate',
    hash: 'Politika hasha pri odašiljanju',
    colMembers: 'Članovi',
    colMode: 'Način',
    noBonds: 'Nijedan bond nije deklariran',
    bridgesTitle: 'Bridgeovi',
    addBridge: 'Dodaj bridge',
    addBridgeTitle: 'Dodajte bridge (add-bridge)',
    editBridgeTitle: 'Uredite bridge',
    editBridge: 'Spremi bridge',
    delBridgeTitle: 'Izbrišite bridge (del-bridge)',
    bridgeName: 'Naziv bridgea',
    stp: 'STP',
    stpOn: 'STP uključen',
    stpOff: 'STP isključen',
    colStp: 'STP',
    noBridges: 'Nijedan bridge nije deklariran',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Postavi hostname',
    setHostnameTitle: 'Postavite hostname (set-hostname)',
    hostnameHint: 'Samo identitet OS-a — naziv čvora u klasteru se ne dira',
    notSet: 'nije postavljen',
    staticHostsTitle: 'Statički host zapisi',
    addStaticHost: 'Dodaj zapis',
    addStaticHostTitle: 'Dodajte statički host zapis',
    delStaticHostTitle: 'Izbrišite statički host zapis',
    hostIp: 'IP adresa',
    hostNames: 'Nazivi',
    hostNamesHint: 'odvojeni zarezom ili razmakom',
    colIp: 'IP',
    colNames: 'Nazivi',
    noStaticHosts: 'Nema statičkih host zapisa',
    delConfirm: 'Uklanjanje {name} iz željenog dokumenta — worker čvora konvergira uz NetworkManager checkpoint i automatski rollback.',
    remove: 'Ukloni',
    opError: 'Mrežna operacija je odbijena'
  }
}
